import * as React from 'react';
import { AreaChart, Area, Brush, XAxis, YAxis, CartesianGrid, Tooltip, Legend, LineChart, Line, ResponsiveContainer } from 'recharts';
import { SubjectDailyTrendModel } from '../progress-widget-app';

interface SubjectWeeklyTrendChartProps {
    visible: boolean;
    data: SubjectDailyTrendModel;
}

export class SubjectWeeklyTrendChart extends React.Component<SubjectWeeklyTrendChartProps, {}> {
    constructor(props: SubjectWeeklyTrendChartProps) {
        super(props);
    }

    render() {
        if (this.props.visible) {
            return (
                <div className="row">
                    <div className="col-md-12">
                        <div className="panel panel-default">
                            <div className="panel-body">
                                <h4 className="text-primary text-center">Subject Trend Graph</h4>
                                <ResponsiveContainer width="100%" height={400}>
                                    <AreaChart data={this.props.data.Days} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                                        <defs>
                                            <linearGradient id="colorDaily" x1="0" y1="0" x2="0" y2="1">
                                                <stop offset="5%" stopColor="#00aeff" stopOpacity={1} />
                                                <stop offset="95%" stopColor="#00aeff" stopOpacity={1} />
                                            </linearGradient>
                                            <linearGradient id="colorRunningTotal" x1="0" y1="0" x2="0" y2="1">
                                                <stop offset="5%" stopColor="#006ba6" stopOpacity={0.8} />
                                                <stop offset="95%" stopColor="#006ba6" stopOpacity={0.8} />
                                            </linearGradient>
                                        </defs>
                                        <XAxis dataKey="Day" />
                                        <YAxis allowDecimals={false} />
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <Tooltip />
                                        <Legend />
                                        <Brush x={200} y={290} data={this.props.data.Days} dataKey="Day" height={80} width={500}>
                                            <AreaChart data={this.props.data.Days}>
                                                <Area type="monotone" name="Cumulative Subjects" dataKey="RunningTotal" stroke="#006ba6" fill="url(#colorRunningTotal)" />
                                                <Area type="monotone" name="Daily Subjects" dataKey="Daily" stroke="#00aeff" fill="url(#colorDaily)" />
                                             </AreaChart>
                                        </Brush>
                                        <Area type="monotone" name="Cumulative Subjects" dataKey="RunningTotal" stroke="#006ba6" fill="url(#colorRunningTotal)" />
                                        <Area type="monotone" name="Daily Subjects" dataKey="Daily" stroke="#00aeff" fill="url(#colorDaily)" />
                                    </AreaChart>
                                </ResponsiveContainer>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
}
